import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation('common');

  return (
    <section className="min-h-screen flex items-center pt-16 md:pt-20">
      <div className="w-full flex flex-col md:grid md:grid-cols-2">
        {/* Left Content */}
        <div className="bg-stone-50 flex items-center justify-center py-14 px-6 md:py-24 md:px-16">
          <div className="max-w-xl w-full space-y-7 md:space-y-10">
            <div className="space-y-3 md:space-y-4">
              <h1 className="text-4xl md:text-7xl font-serif leading-tight text-gray-900">
                {t('hero.title')}
              </h1>
              <p className="text-xl md:text-2xl text-stone-600 font-light">
                {t('hero.subtitle')}
              </p>
            </div>

            <div className="text-gray-700 leading-relaxed">
              <p className="text-sm md:text-base">{t('hero.description1')}</p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-5 pt-2 md:pt-4">
              <a
                href="#booking"
                className="text-center px-8 py-3.5 md:px-12 md:py-4 bg-teal-800 text-amber-400 rounded-full text-sm md:text-base font-medium hover:bg-teal-900 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                {t('hero.bookNow')}
              </a>
              <a
                href="#services"
                className="text-center px-8 py-3.5 md:px-12 md:py-4 border-2 border-amber-500 text-teal-800 rounded-full text-sm md:text-base font-medium hover:bg-amber-50 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                {t('hero.learnMore')}
              </a>
            </div>
          </div>
        </div>

        {/* Right Visual */}
        <div className="bg-gradient-to-br from-stone-300 to-stone-400 p-4 md:p-8 flex items-center justify-center relative" style={{ minHeight: '320px' }}>
          <div className="w-full h-full rounded-2xl md:rounded-3xl overflow-hidden relative" style={{ minHeight: '300px' }}>
            <img
              src="https://public.readdy.ai/ai/img_res/d3741ac5b4a9d3ae687e032a888cfbfc.jpg"
              alt="Sunshine Healing"
              className="w-full h-full object-cover object-top"
              style={{ minHeight: '300px' }}
            />
            <div className="absolute top-4 right-4 md:top-8 md:right-8 px-4 py-2 md:px-6 md:py-3 bg-white/20 backdrop-blur-md rounded-full">
              <span className="text-white text-xs md:text-sm font-medium whitespace-nowrap">{t('hero.bilingual')}</span>
            </div>
          </div>
          {/* Scroll Indicator */}
          <div className="absolute bottom-6 md:bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
            <i className="ri-arrow-down-line text-2xl md:text-3xl text-amber-500"></i>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
